export const ROUTES = {
  root: () => '/',
  login: () => '/login',
  signup: () => '/signup',
  welcome: () => '/welcome',
  inviteExpired: () => '/invite-expired',
  forgotPassword: () => '/forgot-password',
  resetPassword: () => '/reset-password',
  resetPasswordExpired: () => '/reset-password-expired',
  verifyEmail: () => '/verify-email',
  verifyEmailSent: () => '/verify-email-sent',
  verifyEmailSuccess: () => '/verify-email-success',
  verifyEmailFailed: () => '/verify-email-failed',
  // consultant views
  assessments: () => '/assessments',
  assessmentDetail: (id: string) => `/assessments/${id}`,
  assessmentTake: (id: string) => `/assessments/${id}/take`,
  assessmentReport: (id: string) => `/assessments/${id}/report`,
  help: () => '/help',
  // admin views
  admin: () => '/admin',
  adminAssessmentsCreate: () => '/admin/assessments/create',
  adminFrameworks: () => '/admin/frameworks',
  adminFrameworkDetail: (id: string) => `/admin/frameworks/${id}`,
  // The offering is a query param so the Domains page can restore the selected
  // offering when navigating back from a domain's mappings page.
  adminDomains: (offeringId?: string | null) =>
    offeringId ? `/admin/domains?offering=${encodeURIComponent(offeringId)}` : '/admin/domains',
  adminDomainMappings: (id: string, offeringId?: string | null) =>
    offeringId
      ? `/admin/domains/${id}/mappings?offering=${encodeURIComponent(offeringId)}`
      : `/admin/domains/${id}/mappings`,
  adminIndustryBenchmarks: () => '/admin/industry-benchmarks',
  adminUsers: () => '/admin/users',
  adminAuditLog: () => '/admin/audit-log',
  adminTalentBench: () => '/admin/talent-bench',
};
